/**
 * @generated SignedSource<<22cdd2a7992f47102b1903f730d9956b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSignupSummaryHeader_event$data = {
  readonly eventSeries: {
    readonly facility: {
      readonly club: {
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"ClubLogo_Club">;
      } | null | undefined;
    };
  };
  readonly " $fragmentType": "EventSignupSummaryHeader_event";
};
export type EventSignupSummaryHeader_event$key = {
  readonly " $data"?: EventSignupSummaryHeader_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryHeader_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignupSummaryHeader_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ClubLogo_Club"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "e4d312a41f5bcdfc4997a75bc7096387";

export default node;
